import { SOC } from '../../constants/company';
import { C } from '../../theme/palette';

/**
 * Logo de l'entreprise, importé depuis la carte « Modèle des documents ».
 *
 * Reprise de la V288 : on choisit son modèle en regardant l'aperçu, et c'est
 * là qu'on remarque qu'il manque le logo. Plutôt que de renvoyer à l'onglet
 * Société, l'encadré permet de l'importer sur place.
 *
 * Il n'a pas d'état à lui : il lit et écrit les coordonnées que l'onglet
 * Société édite (`coord` / `setCoord`), si bien que le logo est le même aux
 * deux endroits, enregistré de la même façon — y compris, en mode Mix, celui
 * du secteur en cours d'édition. Sans logo, l'initiale de l'entreprise en
 * tient lieu, comme dans l'en-tête des documents.
 *
 * @param {object} props propriétés du composant
 * @param {object} [props.coord] coordonnées de l'entreprise (ou du secteur)
 * @param {(patch: object) => void} props.setCoord applique une modification
 *   aux coordonnées
 * @returns {import('react').ReactElement} l'aperçu du logo et ses commandes
 */
export function LogoDuDocument({ coord, setCoord }) {
  const logo = coord?.logo;
  return (
    <div
      style={{
        display: 'flex',
        gap: 11,
        alignItems: 'center',
        marginBottom: 12,
        padding: '10px 11px',
        background: C.navyXL,
        borderRadius: 10,
      }}
    >
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: 12,
          background: logo ? '#fff' : C.white,
          border: '1px solid ' + C.border,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          flexShrink: 0,
        }}
      >
        {logo ? (
          <img
            src={logo}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            alt="Logo de l’entreprise"
          />
        ) : (
          <span style={{ fontSize: 20, fontWeight: 900, color: C.navy }}>
            {(coord?.nom || SOC.nom).charAt(0)}
          </span>
        )}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 10, fontWeight: 800, color: C.ink, marginBottom: 4 }}>
          Ton logo sur le document
        </div>
        <label
          style={{
            display: 'inline-block',
            background: C.navy,
            color: '#fff',
            borderRadius: 9,
            padding: '7px 11px',
            fontSize: 10,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {logo ? '📷 Changer mon logo' : '📷 Importer mon logo'}
          <input
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={(e) => {
              // Lecture identique à celle de l'onglet Société : le logo voyage
              // avec les coordonnées, en adresse de données.
              const f = e.target.files && e.target.files[0];
              if (f) {
                const r = new FileReader();
                r.onload = () => setCoord({ logo: r.result });
                r.readAsDataURL(f);
              }
            }}
          />
        </label>
        {logo && (
          <button
            type="button"
            onClick={() => setCoord({ logo: null })}
            style={{
              marginLeft: 8,
              background: 'none',
              border: 'none',
              padding: 0,
              color: C.red,
              fontSize: 10,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Retirer
          </button>
        )}
      </div>
    </div>
  );
}
